import * as React from 'react';
import WizardCard from '../../components/WizardCard/WizardCard';
import './InstagramProfile.styles.scss';
import FormField from '../../components/FormField/FormField';
import Appear from '../../components/Appear/Appear';
import axios from 'axios';
import { BASE_SERVER_URL } from '../../Constants';
import withContainer from '../../containers/WithContainer';
import { withRouter } from 'react-router-dom';

interface InstagramProfileState {
  username: string;
  isSearching: boolean;
  profileImg: string;
  name: string;
  found: boolean;
}

interface InstagramProfileProps {
  appContainer: any;
  match: any;
}
class InstagramProfile extends React.Component<
  InstagramProfileProps,
  InstagramProfileState
  > {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      isSearching: false,
      profileImg: '',
      name: '',
      found: false,
    };
  }

  handleSearch = async () => {
    await this.setState({ isSearching: true });
    // simulate http call
    await this.fetchProfile();
    this.setState({
      isSearching: false,
    });
  };

  handleInputChange = e => {
    this.setState({ username: e.target.value });
  };

  fetchProfile = async () => {
    let username = this.props.appContainer.state.step4.instagram.username;
    if (username[0] === '@') username = username.slice(1);
    const url = `${BASE_SERVER_URL}/find-instagram-account`;
    let response = await axios.get(url, { params: { username } });
    if (response.data === 'found') {
      this.props.appContainer.setInstagramUsername(username);
      this.props.appContainer.setInstagramFound(true);
      this.setState({
        name: this.props.appContainer.state.step4.instagram.username,
      });

      return;
    } else {
      this.props.appContainer.setInstagramFound(false);
      this.setState({
        name:
          'Could not find ' +
          this.props.appContainer.state.step4.instagram.username,
      });
      return;
    }
  };

  onNext = () => {
    this.props.appContainer.updateInstagram(this.getCurrStep());
  };

  getCurrStep = () => {
    let step = parseInt(this.props.match.path.split('-')[1]);
    return step;
  };

  public render() {
    const username = this.props.appContainer.state.step4.instagram.username;
    const { profileImg, name, isSearching } = this.state;
    return (
      <WizardCard
        title="What's your Instagram profile?"
        subTitle="To get pictures of your work we need your Instagram profile."
        isDisabled={!this.props.appContainer.state.step4.instagram.found}
        delay={2}
        onNext={this.onNext}
      >
        <Appear delay={1.5}>
          <div className="level">
            <div className="level-item">
              <div className="InstagramProfile__instagram-logo" />
            </div>
          </div>
        </Appear>

        <Appear delay={1.8}>
          <div className="has-margin-top-20">
            <FormField
              label=""
              hasAddon
              isInputExpanded
              addonLabel="Search"
              addonIcon={<i className="fas fa-search" />}
              onBtnClick={this.handleSearch}
              isAddonBtnDisabled={!username}
              addOnBtnClassName="plus-button"

            >
              <input
                type="text"
                placeholder="instagram username"
                className="input"
                name="username"
                value={this.props.appContainer.state.step4.instagram.username}
                onChange={this.props.appContainer.handleInstagramUsernameChange}
              />
            </FormField>
            <span>Hit <i>search</i> once you have entered your Instagram profile, so we can verify your account</span>
          </div>
        </Appear>

        <div className="has-margin-top-20 level">
          <div className="level-item flex-column">
            {isSearching && (
              <>
                <div className="loader" />
                <div className="has-margin-top-5 has-text-grey-light is-size-7">
                  Searching your profile...
                </div>
              </>
            )}
            {!isSearching && name && (
              <>
                {/* <figure className="image is-64x64 has-margin-top-10 InstagramProfile__instagram-bg is-round">
                  <img src={profileImg} alt="profile picture" className="is-rounded" />
                </figure> */}
                <div className="subtitle is-5 has-text-grey has-margin-top-5">
                  <>
                    {this.props.appContainer.state.step4.instagram.found && (
                      <> Found </>
                    )}
                    {name}
                    {this.props.appContainer.state.step4.instagram.found && (
                      <>
                        {' '}
                        &nbsp;{' '}
                        <i
                          style={{ color: 'green' }}
                          className="fas fa-check"
                        />
                      </>
                    )}
                    {!this.props.appContainer.state.step4.instagram.found && (
                      <>
                        {' '}
                        &nbsp;{' '}
                        <i style={{ color: 'red' }} className="fas fa-times" />
                      </>
                    )}
                  </>
                </div>
                {this.props.appContainer.state.step4.instagram.found && (
                  <div className="has-margin-top-15 is-size-6 has-text-centered">
                    <strong>Note:</strong> Please make sure your profile is
                    public.
                  </div>
                )}
                {/* {
                  this.props.appContainer.state.step4.instagram.found &&
                  <div className="has-margin-top-25">
                    <span className="is-touch-only">
                      Tap&nbsp;
                      </span>
                    <span className="is-touch-hidden">
                      Click&nbsp;
                      </span>
                    <span>
                      <span className="has-text-weight-semibold">Next&nbsp;</span>
                      if this is your profile.
                      </span>
                  </div>
                } */}
              </>
            )}
          </div>
        </div>
      </WizardCard>
    );
  }
}

export default withRouter(withContainer(InstagramProfile));
